module.exports = __webpack_public_path__ + "img/bgimagepinc.225c5040.png";